import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AppBar, Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import ApartmentIcon from "@mui/icons-material/Apartment";
import authService from "../../services/auth/authService";
import Sidebar from "../../components/Shared/Sidebar";
import { getSidebarUserInfo } from "../../services/My/service";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
interface User {
    name: string;
    avatarUrl?: string;
}

const Home: React.FC = () => {
    const drawerWidth = 240;
    const [user, setUser] = useState<User | null>(null);

    const handleLogout = () => {
        authService.logout();
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getSidebarUserInfo();
                setUser({
                    name: userData.full_name,
                    avatarUrl: undefined,
                });
            } catch (error) {
                console.error("Failed to fetch sidebar user info:", error);
            }
        };

        fetchUser();
    }, []);

    const menuItems = [
        {
            id: "account-roots",
            label: "Account Roots",
            icon: <ApartmentIcon />,
            path: "/eyeviation-super/account-roots",
        },
        {
            id: "client-admins",
            label: "Client Admins",
            icon: <SupervisorAccountIcon />,
            path: "/eyeviation-super/client-admins"
        },
        {
            id: "vcat-kits",
            label: "VCAT Kits",
            icon: <HomeRepairServiceIcon />,
            path: "/eyeviation-super/vcat-kits",
        },

        {
            id: "active-sessions",
            label: "Active Sessions",
            icon: <PersonIcon />,
            path: "/eyeviation-super/active-sessions",
        },



    ];
    const bottomItems = [
        //{ id: "history", label: "History", icon: <HistoryIcon />, path: "history" },
        { id: "user-info", label: user?.name || "User Info", icon: <PersonIcon />, path: "user-info" },
    ];


   return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#0D1117" }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#161B22",
          boxShadow: "none",
        }}
      />

      <Sidebar
        menuItems={menuItems}
        bottomItems={bottomItems}
        onLogout={handleLogout}
        logoSrc="/logo.png"

      />


      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 4,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          backgroundColor: "#0E1720",
          minHeight: "100vh",
          position: "relative",
        }}
      >
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "160px",
              background: "linear-gradient(to bottom, rgba(29, 176, 191, 0.3), transparent)",
              zIndex: 0,
            }}
          />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                width: { sm: `calc(100%)` },
                backgroundColor: "rgba(14, 23, 32, 0)",               
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                position: "relative",
                
              }}
            >
              <Box sx={{ p: 4, flexGrow: 1 }}>
                <Outlet />
              </Box>

              <Box sx={{ py: 2, textAlign: "center", width: "100%" }}>
                <Typography variant="caption" sx={{ color: "#A8B2D1" }}>
                  © {new Date().getFullYear()} VCAT. All rights reserved.
                </Typography>
              </Box>
            </Box>

                  </Box>
                </Box>
              );
            };

export default Home;
